export function NewDiplomatsSignup() {
  return (
    <section className="bg-background" aria-labelledby="new-diplomats-heading">
      <div className="mx-auto grid w-full max-w-[1400px] gap-10 px-5 py-16 lg:grid-cols-2 lg:gap-16 lg:px-8 lg:py-24">
        <div>
          <p className="fc-body fc-rule text-foreground">
            Just arrived in Germany as a foreign diplomat?
          </p>
          <h2 id="new-diplomats-heading" className="fc-h2 mt-8 text-foreground">
            Sign up for an invitation to our next induction seminar for newly arrived diplomats.
          </h2>
          <div className="mt-8 fc-body text-foreground">
            <p className="font-bold">Important!</p>
            <p>Registration is only possible with an official e-mail address (ministry, embassy, etc.).</p>
            <p>The briefing takes place in English.</p>
            <p>Participation is free of charge.</p>
          </div>
        </div>

        <form
          className="bg-highlight p-6 lg:p-8"
          onSubmit={(event) => event.preventDefault()}
        >
          {[
            { label: "Title (H.E. / Prof / Dr)", required: false, type: "text" },
            { label: "First name", required: true, type: "text" },
            { label: "Last name", required: true, type: "text" },
            { label: "Email (Embassy)", required: true, type: "email" },
            { label: "Country", required: true, type: "text" },
          ].map((field) => (
            <label key={field.label} className="mb-5 block">
              <span className="fc-body text-highlight-foreground">
                {field.label}
                {field.required && <span className="text-accent">*</span>}
              </span>
              <input
                type={field.type}
                required={field.required}
                className="mt-1 h-11 w-full border border-border bg-secondary px-3 text-base text-foreground outline-none focus:border-accent"
              />
            </label>
          ))}

          <button
            type="submit"
            className="bg-accent px-6 py-3 text-base font-bold text-accent-foreground transition-opacity hover:opacity-85"
          >
            Submit
          </button>
        </form>
      </div>
    </section>
  );
}
